// @vue/component
export default {
  name: "PuxMock",
};
